import React, { Component } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import { reducer as formReducer } from 'redux-form'
import auth from './sections/auth/reducer'
import commonReducer from './store/commonReducer'
import navigationReducer from './store/navigation'
import { reducers } from './store/redux'

import Main from './components/main'

import axios from 'axios'

import './App.css'

// axios config
axios.defaults.baseURL = `${process.env.REACT_APP_API}`

// redux

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  combineReducers({
    navigation: navigationReducer,
    ...reducers,
    commonReducer,
    auth,
    form: formReducer
  }),
  composeEnhancers(
    applyMiddleware(thunk)
  )
)

const theme = createTheme();

class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <Router>
          <Provider store={store}>
            <Routes>
              <Route path="/*" element={<Main />} />
            </Routes>
          </Provider>
        </Router>
      </ThemeProvider>
    );
  }
}

export default App;
